'use strict';
//http://jsfiddle.net/bcaudan/vTZZ5/

module.exports = /*@ngInject*/ ["$parse", function ($parse) {
    return function (scope, element, attrs) {
        var fn = $parse(attrs.rightClick);
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, {$event: event});
            });
        });
    };
}];

